<template>
  <div id="app">
    <div class="app-view-wrapper">
      <div class="app-view"
           :class="{'app-view-width-footer':footerBar}">
        <div class="page-wrap">
          <div class="bodys">
            <HeaderTools @shareTarget="watchShare"
                         :title="title"
                         v-if="headerTools"></HeaderTools>
            <keep-alive>
              <router-view @viewTitle="watchTitle"
                           @shareTarget="watchShare"
                           :prop-share="share"
                           @shareImgTarget="watchShareImg"
                           @shareRouteTarget="watchShare"
                           @hasHeaderTools="handleHeaderTools"
                           @hasFooterBar="handleFooterBar"
                           v-if="this.$route.meta.keepAlive && isRouterAlive"></router-view>
            </keep-alive>
            <router-view @shareTarget="watchShare"
                         :prop-share="share"
                         @shareImgTarget="watchShareImg"
                         @hasHeaderTools="handleHeaderTools"
                         @hasFooterBar="handleFooterBar"
                         v-if="!this.$route.meta.keepAlive && isRouterAlive">
            </router-view>
          </div>
          <Share @shareTarget="watchShare"
                 :prop-share-img="shareImg"
                 :prop-share-type="shareType"
                 :prop-share="share">
          </Share>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderTools from '@/components/common/headerTools';
import Share from '@/components/common/share';
export default {
  name: 'App',
  data () {
    return {
      title: this.$route.meta.title,
      footerBar: true,
      headerTools: true,
      share: false,
      shareImg: "",
      shareType: 0,
      isRouterAlive: true
    }
  },
  provide(){
    return {
      reload: this.reload
    }
  },
  components: {
    HeaderTools,
    Share
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    handleFooterBar (newValue) {
      this.footerBar = newValue;
    },
    handleHeaderTools (newValue) {
      this.headerTools = newValue;
    },
    //监听分享类型
    watchShare (newValue) {
      this.share = newValue.share;
      this.shareType = newValue.shareType;
    },
    //监听是否是否有分享图片
    watchShareImg (newValue) {
      this.shareImg = newValue;
      this.shareType = 1;
    },
    watchTitle (newValue) {
      this.title = newValue;
    }
  },
  watch: {
    '$route' (to, from) {
      this.title = to.meta.title;
    },
  },
  mounted () {

  }
}

</script>
<style lang="scss">
body{
  position: relative;
  overflow-x: hidden;
}
#app {
  box-sizing: border-box;
  color: #333;
  font-family: Helvetica Neue, Tahoma, Arial, PingFangSC-Regular,
    Hiragino Sans GB, Microsoft Yahei, sans-serif;
  line-height: 1.15;
  -webkit-user-select: none;
  user-select: none;
  -webkit-font-smoothing: antialiased;
  touch-action: manipulation;
  -webkit-text-size-adjust: none;
  text-size-adjust: none;
  font-size: 0.32rem;
}

.ui-header ~ .app-view {
  border-top: 55px solid transparent;
}

.header-tools ~ .tab-wrapper {
  padding-top: 45px;
}

.tab-nav ~ .tab-container {
  padding-bottom: 50px;
}

* {
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}
</style>
